// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uMzMv","right":"styles_right__2mfLQ"};